import React, { useState } from "react";

const faqs = [
  {
    question: "Can I buy and sell MONKZI freely?",
    answer: "Yes! You can buy or sell MONKZI anytime on PancakeSwap and other listed DEXs. Just respect the contract’s transaction limits: max 10,000,000 MONKZI per trade."
  },
  {
    question: "How much MONKZI can I hold?",
    answer: "Each wallet can hold up to 20,000,000 MONKZI (2% of the total supply)."
  },
  {
    question: "What wallet should I use?",
    answer: "MONKZI is a BEP20 token on Binance Smart Chain. We recommend MetaMask or TrustWallet. Add MONKZI manually using our contract address if it doesn’t appear."
  },
  {
    question: "Need support?",
    answer: <>Join our <a href="https://t.me/monkillaofficial" style={{color: "#FFD700", fontWeight: "bold"}}>Telegram</a> or email <a href="mailto:info@monkilla.com" style={{color: "#FFD700"}}>info@monkilla.com</a>.</>
  },
  {
    question: "Who is the founder of MONKZI?",
    answer: <>
      <b>Damanpreet Singh</b><br />
      <a
        href="https://www.linkedin.com/in/damanpreet-singh-97894578"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#FFD700", fontWeight: "bold", textDecoration: "underline" }}
      >
        LinkedIn Profile
      </a>
    </>
  }
];

const AccordionItem = ({ faq, isOpen, onClick }) => (
  <div style={{
    marginBottom: "13px",
    borderRadius: "14px",
    border: "1.3px solid #FFD700",
    background: isOpen ? "rgba(255,215,0,0.08)" : "rgba(20,30,40,0.78)",
    boxShadow: isOpen ? "0 4px 20px rgba(246,195,67,0.10)" : "none",
    transition: "background .23s, box-shadow .18s"
  }}>
    <button
      onClick={onClick}
      style={{
        width: "100%",
        textAlign: "left",
        background: "none",
        border: "none",
        color: "#FFD700",
        fontWeight: "bold",
        padding: "17px 20px",
        fontSize: "1.11em",
        cursor: "pointer",
        outline: "none",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}
      aria-expanded={isOpen}
    >
      {faq.question}
      <span style={{
        fontWeight: "bold",
        fontSize: "1.33em",
        marginLeft: "15px"
      }}>{isOpen ? "−" : "+"}</span>
    </button>
    {isOpen && (
      <div style={{
        padding: "0 20px 18px 20px",
        color: "#e0e0e0",
        fontSize: "1.09em",
        animation: "fadeIn .2s"
      }}>
        {faq.answer}
      </div>
    )}
  </div>
);

const FAQSection = () => {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section style={{
      margin: "48px 0 32px 0",
      background: "rgba(20,30,40,0.78)",
      borderRadius: "20px",
      padding: "32px 20px",
      maxWidth: "800px",
      textAlign: "left"
    }}>
      <h2 style={{ color: "#FFD700", fontWeight: "bold", fontSize: "1.34em", marginBottom: "16px" }}>
        🤔 Frequently Asked Questions (FAQ)
      </h2>
      {faqs.map((faq, idx) => (
        <AccordionItem
          key={idx}
          faq={faq}
          isOpen={openIdx === idx}
          onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
        />
      ))}
      <div style={{ textAlign: "center", marginTop: "22px" }}>
        <a
          href="https://t.me/monkillaofficial"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            background: "#FFD700",
            color: "#07333c",
            fontWeight: "bold",
            fontSize: "1.11em",
            padding: "13px 38px",
            borderRadius: "30px",
            textDecoration: "none",
            margin: "0 10px",
            boxShadow: "0 4px 20px rgba(246,195,67,0.10)",
            letterSpacing: "1px"
          }}
        >
          💬 Contact Support
        </a>
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-8px);}
          to { opacity: 1; transform: translateY(0);}
        }
      `}</style>
    </section>
  );
};

export default FAQSection;
